module.exports = __webpack_public_path__ + "static/media/labImage.8a51df9d.svg";